<section id="section-report" class="container-fluid mt-1">
  <div class="row" *ngIf="transferConstructionSitePrintModel">
    <div id="container-report" class="col-12 col-lg-12">
      <table class="page" id="transfer-construction-site">
        <thead id="thead">
          <tr>
            <th id="th-head">
              <div class="row">
                <div id="head-{{transferConstructionSitePrintModel.transferConstructionSiteId}}"
                  class="head col-12 col-lg-12">

                  <!-- Logo -->
                  <img id="logo-{{transferConstructionSitePrintModel.transferConstructionSiteId}}"
                    [src]="logoEnterprise" alt="" (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">

                  <!-- Nombre Empresa -->
                  <p id="nombre-empresa-{{transferConstructionSitePrintModel.transferConstructionSiteId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{transferConstructionSitePrintModel.enterpriseName}}</p>

                  <!--Nombre Sucursal -->
                  <p id="nombre-sucursal-{{transferConstructionSitePrintModel.transferConstructionSiteId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{transferConstructionSitePrintModel.branchName}}</p>

                  <!--Nombre traslado -->
                  <p id="nombre-traslado-{{transferConstructionSitePrintModel.transferConstructionSiteId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{transferConstructionSitePrintModel.nameTransferConstructionSite}}</p>

                  <!-- Dirección -->
                  <label id="t-direccion-{{transferConstructionSitePrintModel.transferConstructionSiteId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-direccion' | formatLabelPipe :
                    elementsLabel}}</label>
                  <p id="direccion-{{transferConstructionSitePrintModel.transferConstructionSiteId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{transferConstructionSitePrintModel.addressBranch}}</p>

                  <!-- Teléfono  -->
                  <label id="t-telefono-{{transferConstructionSitePrintModel.transferConstructionSiteId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-telefono' | formatLabelPipe :
                    elementsLabel}}</label>
                  <p id="telefono-{{transferConstructionSitePrintModel.transferConstructionSiteId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{transferConstructionSitePrintModel.phoneBranch}}</p>

                  <!-- Fecha traslado  -->
                  <label id="t-fecha-traslado-{{transferConstructionSitePrintModel.transferConstructionSiteId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-fecha-traslado' | formatLabelPipe
                    : elementsLabel}}</label>
                  <p id="fecha-traslado-{{transferConstructionSitePrintModel.transferConstructionSiteId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{transferConstructionSitePrintModel.dateTransferConstructionSite | date: 'dd/MM/yyyy hh:mm:ss'}}
                  </p>

                  <!-- Cliente Origen -->
                  <label id="t-origen-cliente-{{transferConstructionSitePrintModel.transferConstructionSiteId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-origen-cliente' | formatLabelPipe
                    :
                    elementsLabel}}</label>
                  <p id="origen-cliente-{{transferConstructionSitePrintModel.transferConstructionSiteId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{transferConstructionSitePrintModel.originClientNitAndBusinessName}}
                  </p>

                  <!-- C.Costos Origen -->
                  <label id="t-origen-centro-costos-{{transferConstructionSitePrintModel.transferConstructionSiteId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-origen-centro-costos' |
                    formatLabelPipe
                    : elementsLabel}}</label>
                  <p id="origen-centro-costos-{{transferConstructionSitePrintModel.transferConstructionSiteId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{transferConstructionSitePrintModel.originCostCenterCodeName}}
                  </p>

                  <!-- Cliente Destino -->
                  <label id="t-destino-cliente-{{transferConstructionSitePrintModel.transferConstructionSiteId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-destino-cliente' |
                    formatLabelPipe :
                    elementsLabel}}</label>
                  <p id="destino-cliente-{{transferConstructionSitePrintModel.transferConstructionSiteId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{transferConstructionSitePrintModel.destinyClientNitAndBusinessName}}
                  </p>

                  <!-- C.Costos Destino -->
                  <label id="t-destino-centro-costos-{{transferConstructionSitePrintModel.transferConstructionSiteId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-destino-centro-costos' |
                    formatLabelPipe
                    : elementsLabel}}</label>
                  <p id="destino-centro-costos-{{transferConstructionSitePrintModel.transferConstructionSiteId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{transferConstructionSitePrintModel.destinyCostCenterCodeName}}
                  </p>

                  <!-- Nro Remisión  -->
                  <label id="t-consecutivo-remision-{{transferConstructionSitePrintModel.transferConstructionSiteId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-consecutivo-remision' |
                    formatLabelPipe :
                    elementsLabel}}</label>
                  <p id="consecutivo-remision-{{transferConstructionSitePrintModel.transferConstructionSiteId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{transferConstructionSitePrintModel.consecutiveRemission}}</p>

                  <!-- Nro Devolución  -->
                  <label id="t-consecutivo-devolucion-{{transferConstructionSitePrintModel.transferConstructionSiteId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-consecutivo-devolucion' |
                    formatLabelPipe :
                    elementsLabel}}</label>
                  <p id="consecutivo-devolucion-{{transferConstructionSitePrintModel.transferConstructionSiteId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{transferConstructionSitePrintModel.consecutiveDevolution}}</p>
                </div>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <div class="table-container">
                <app-custom-table-print
                  id="detalle-traslado-entre-obras-{{transferConstructionSitePrintModel.transferConstructionSiteId}}"
                  [columns]="columns" [data]="transferConstructionSitePrintModel.transferConstructionSiteDetails"
                  [idMap]="idMap" [documentId]="transferConstructionSitePrintModel.transferConstructionSiteId"
                  [footerVisible]="true" [editFormat]="editFormat" (clickTableEvent)="clickTable($event)"
                  (newIndexColumns)="onColumnReorder($event)"></app-custom-table-print>
              </div>
              <!-- Observación traslado -->
              <div id="foot-{{transferConstructionSitePrintModel.transferConstructionSiteId}}"
                class="foot container-observations">
                <p id="linea-firma-observacion-{{transferConstructionSitePrintModel.transferConstructionSiteId}}"
                  class="write-line" (click)="onClick()" (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                </p>
                <label id="t-observacion-traslado-{{transferConstructionSitePrintModel.transferConstructionSiteId}}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-observacion-traslado' |
                  formatLabelPipe :
                  elementsLabel}}</label>
                <p id="observación-traslado-{{transferConstructionSitePrintModel.transferConstructionSiteId}}"
                  class="lh-sm observation-traslado" (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"
                  *ngIf="transferConstructionSitePrintModel.observation">
                  {{ transferConstructionSitePrintModel.observation }}
                </p>

                <!-- Firma Entrega -->
                <p id="linea-firma-entrega-{{transferConstructionSitePrintModel.transferConstructionSiteId}}"
                  class="write-line" (click)="onClick()" (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                </p>
                <label id="t-linea-entrega-{{transferConstructionSitePrintModel.transferConstructionSiteId}}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-linea-entrega' | formatLabelPipe :
                  elementsLabel}}</label>

                <!-- Firma Recibe -->
                <p id="linea-firma-recibe-{{transferConstructionSitePrintModel.transferConstructionSiteId}}"
                  class="write-line" (click)="onClick()" (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                </p>
                <label id="t-linea-recibe-{{transferConstructionSitePrintModel.transferConstructionSiteId}}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-linea-recibe' | formatLabelPipe :
                  elementsLabel}}</label>
              </div>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="1" id="td-foot">
              <div class="information-print d-flex">
                <p id="version-cervino" class="fw-bold pe-4">{{ version }}</p>
                <label id="t-fecha-impresion" class="fw-bold pe-2">Fecha:
                </label>
                <p id="fecha-impresion" class="pe-4">
                  {{ dateNow | date : "dd/MM/yyyy" }}
                </p>
                <label id="t-hora-impresion" class="fw-bold pe-2">Hora: </label>
                <p id="hora-impresion" class="pe-4">
                  {{ dateNow | date : "hh:mm:ss a" }}
                </p>
                <label id="t-usuario-impresion" class="fw-bold pe-2">Usuario:
                </label>
                <p id="usuario-impresion" class="pe-4">
                  {{ userAuthenticated }}
                </p>
              </div>
              <div class="d-flex flex-column justify-content-center">
                <div class="d-flex justify-content-center">
                  <p class="mt-2 information-print">
                    Documento generado con el Software Cervino Web de Altos
                    Software SAS. Nit.811.022.121-1. www.altos-soft.com
                  </p>
                </div>
              </div>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</section>